import { getRequest } from "../utils/fetch";
import { objectToQueryString } from "../utils/querystring";
import { IProductCategoryReviewsRequest, IProductCategoryReviewsResult } from "./content-service";

const basePath = "/apicore/reviewsapi/";

export function GetProductCategoryReviews(
	productCategoryId: string,
	page: number,
	stars?: number,
	reviewLanguage?: string,
	theme?: string,
): Promise<IProductCategoryReviewsResult> {
	const request: IProductCategoryReviewsRequest = {
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		productCategoryId: productCategoryId,
		page: page,
		stars: stars || 0,
		reviewLanguage: reviewLanguage || "",
		theme: theme || "",
	};
	return getRequest<IProductCategoryReviewsResult>(
		basePath + "getproductcategoryreviews" + objectToQueryString(request),
		{ headers: new Headers({ "Content-type": "application/json; charset=utf-8" }) },
	).then((res) => {
		return res;
	}) as Promise<IProductCategoryReviewsResult>;
}
